const SearchWithStarts = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="116"
        height="116"
        fill="none"
        viewBox="0 0 116 116"
    >
        <g id="Layer_1" clipPath="url(#clip0_9269_12549)">
            <g id="Group" fill="#0FF">
                <path
                    id="Vector"
                    d="m75.048 10.902 1.47-.492.492 1.474a.842.842 0 1 0 1.598-.535l-.492-1.474 1.471-.493a.845.845 0 0 0-.533-1.601l-1.471.492L77.09 6.8a.842.842 0 1 0-1.597.535l.49 1.474-1.47.493a.845.845 0 0 0 .534 1.601"
                />
                <path
                    id="Vector_2"
                    d="m108.624 7.472-.559 1.535-1.532-.56a.887.887 0 0 0-.606 1.667l1.531.56-.558 1.535a.884.884 0 1 0 1.662.608l.559-1.535 1.531.56a.887.887 0 0 0 .607-1.668l-1.531-.56.559-1.535a.887.887 0 0 0-1.664-.608z"
                />
                <path
                    id="Vector_3"
                    d="m109.064 77.817.425.566-.565.425a.385.385 0 0 0 .463.615l.564-.426.425.566a.384.384 0 1 0 .613-.463l-.424-.566.564-.425a.385.385 0 0 0-.462-.615l-.565.425-.424-.566a.384.384 0 1 0-.614.464"
                />
                <path
                    id="Vector_4"
                    d="m6.94 13.632-.146-.597.596-.147a.334.334 0 0 0-.16-.65l-.596.148-.146-.598a.333.333 0 1 0-.648.16l.147.597-.596.147a.334.334 0 0 0 .159.65l.596-.148.147.598a.333.333 0 1 0 .647-.16"
                />
                <path
                    id="Vector_5"
                    d="m.492 52.078.519-.305.304.52a.326.326 0 1 0 .563-.331l-.304-.52.518-.305a.328.328 0 0 0-.33-.564l-.519.305-.304-.52a.326.326 0 1 0-.563.331l.304.52-.518.305a.328.328 0 0 0 .33.564"
                />
                <path
                    id="Vector_6"
                    d="M40.548 4.942a2.195 2.195 0 0 1-3.104-.089 2.207 2.207 0 0 1 .087-3.111 2.195 2.195 0 0 1 3.105.088 2.207 2.207 0 0 1-.088 3.111m-2.202-2.337a1.016 1.016 0 0 0-.04 1.432 1.01 1.01 0 0 0 1.428.041 1.016 1.016 0 0 0 .04-1.432 1.01 1.01 0 0 0-1.428-.04"
                />
                <path
                    id="Vector_7"
                    d="M112.373 42.058a1.346 1.346 0 0 1 1.615-1.003c.72.17 1.169.897.999 1.619a1.345 1.345 0 0 1-1.615 1.002 1.347 1.347 0 0 1-.999-1.618m1.909.45a.618.618 0 1 0-.001 0z"
                />
                <path
                    id="Vector_8"
                    d="M48.958 107.566a2.537 2.537 0 0 1 2.424-2.639 2.537 2.537 0 0 1 .209 5.068 2.534 2.534 0 0 1-2.632-2.429m3.692-.152a1.166 1.166 0 0 0-1.211-1.118 1.168 1.168 0 0 0 .096 2.332 1.17 1.17 0 0 0 1.115-1.214"
                />
                <path
                    id="Vector_9"
                    d="M104.648 115.528a1.91 1.91 0 0 1-1.442-2.276 1.904 1.904 0 0 1 2.271-1.445 1.91 1.91 0 0 1 1.441 2.276 1.903 1.903 0 0 1-2.27 1.445m.605-2.716a.877.877 0 0 0-.382 1.713.877.877 0 0 0 .382-1.712z"
                />
            </g>
            <g id="Group_2" fill="#000">
                <path
                    id="Vector_10"
                    d="m76.023 9.76 1.471-.492.492 1.474a.842.842 0 1 0 1.597-.535l-.491-1.474 1.47-.492a.845.845 0 0 0-.533-1.602l-1.47.493-.492-1.475a.842.842 0 1 0-1.598.535l.492 1.475-1.471.492a.845.845 0 0 0 .533 1.602"
                />
                <path
                    id="Vector_11"
                    d="m93.642 46.213-1.958.838-.836-1.962a1.155 1.155 0 1 0-2.125.91l.836 1.962-1.957.838a1.16 1.16 0 0 0-.609 1.52c.251.588.93.861 1.517.61l1.957-.838.837 1.961a1.155 1.155 0 1 0 2.125-.91l-.837-1.961 1.958-.838a1.16 1.16 0 0 0 .608-1.52 1.155 1.155 0 0 0-1.516-.61"
                />
                <path
                    id="Vector_12"
                    d="m109.6 6.33-.559 1.536-1.532-.56a.885.885 0 0 0-1.135.529c-.167.46.069.97.528 1.137l1.532.56-.559 1.536a.885.885 0 1 0 1.663.608l.559-1.536 1.531.56a.888.888 0 0 0 .607-1.668l-1.531-.559.559-1.535a.885.885 0 1 0-1.664-.608z"
                />
                <path
                    id="Vector_13"
                    d="m110.04 76.675.425.566-.565.426a.384.384 0 1 0 .462.615l.565-.426.424.566a.384.384 0 1 0 .614-.463l-.425-.566.565-.426a.385.385 0 0 0-.462-.615l-.565.426-.425-.566a.385.385 0 0 0-.613.463"
                />
                <path
                    id="Vector_14"
                    d="m7.916 12.49-.147-.597.597-.147a.334.334 0 0 0-.16-.649l-.596.147-.146-.598a.333.333 0 1 0-.648.16l.146.598-.596.146a.334.334 0 0 0 .16.65l.596-.147.146.597a.333.333 0 1 0 .648-.16"
                />
                <path
                    id="Vector_15"
                    d="m1.468 50.937.518-.305.305.519a.326.326 0 1 0 .563-.331l-.305-.52.518-.304a.328.328 0 0 0-.33-.565l-.518.305-.304-.52a.326.326 0 1 0-.563.332l.304.52-.518.304a.328.328 0 0 0 .33.565"
                />
                <path
                    id="Vector_16"
                    d="M41.524 3.8a2.195 2.195 0 0 1-3.105-.088A2.207 2.207 0 0 1 38.507.6a2.195 2.195 0 0 1 3.105.088 2.207 2.207 0 0 1-.088 3.112M39.32 1.464a1.016 1.016 0 0 0-.04 1.432 1.01 1.01 0 0 0 1.428.04 1.016 1.016 0 0 0 .04-1.431 1.01 1.01 0 0 0-1.428-.041"
                />
                <path
                    id="Vector_17"
                    d="M113.349 40.916a1.344 1.344 0 0 1 1.614-1.002 1.345 1.345 0 0 1-.615 2.62 1.35 1.35 0 0 1-1-1.617zm1.909.45a.618.618 0 1 0-.001 0z"
                />
                <path
                    id="Vector_18"
                    d="M49.934 106.425a2.537 2.537 0 0 1 2.423-2.639 2.537 2.537 0 0 1 .21 5.068 2.535 2.535 0 0 1-2.632-2.429zm3.692-.153a1.167 1.167 0 0 0-1.212-1.118 1.168 1.168 0 0 0 .096 2.332 1.167 1.167 0 0 0 1.116-1.214"
                />
                <path
                    id="Vector_19"
                    d="M17.317 85.946a4.295 4.295 0 0 1-5.89 1.493 4.316 4.316 0 0 1-1.488-5.903 4.295 4.295 0 0 1 5.889-1.492 4.316 4.316 0 0 1 1.489 5.902m-5.387-3.22a1.986 1.986 0 0 0 .685 2.717c.936.56 2.152.251 2.711-.687a1.977 1.977 0 1 0-3.396-2.03"
                />
                <path
                    id="Vector_20"
                    d="M105.623 114.386a1.91 1.91 0 0 1-1.441-2.275 1.903 1.903 0 0 1 2.27-1.445 1.91 1.91 0 0 1 1.442 2.276 1.904 1.904 0 0 1-2.271 1.444m.606-2.716a.879.879 0 0 0-.382 1.713.876.876 0 0 0 .382-1.712z"
                />
            </g>
            <path
                id="Vector_21"
                fill="#EAEAEA"
                d="M65.454 57.184a21 21 0 0 0 2.747-3.582c5.99-9.897 2.829-22.834-7.045-28.838-9.875-6.003-22.781-2.836-28.771 7.062s-2.83 22.834 7.045 28.838c6.312 3.837 13.855 3.912 20.046.893L78.448 87.28c.807 1.094 1.78 1.99 2.807 2.615.823.5 1.682.826 2.518.94 1.097.148 2.073-.087 2.825-.679.751-.592 1.21-1.487 1.326-2.59.197-1.89-.62-4.143-2.189-6.025l-20.28-24.356"
            />
            <g id="Group_3" fill="#000">
                <path
                    id="Vector_22"
                    d="M59.728 24.784C49.79 18.742 36.8 21.93 30.772 31.892s-2.847 22.98 7.09 29.023c9.939 6.042 22.93 2.853 28.957-7.107s2.847-22.981-7.091-29.023zm-20.946 34.61c-9.1-5.533-12.014-17.456-6.493-26.58s17.417-12.043 26.519-6.51c9.102 5.534 12.015 17.458 6.494 26.58-5.522 9.124-17.418 12.043-26.52 6.51"
                />
                <path
                    id="Vector_23"
                    d="m90.587 88.632-23.913-28.72a24.7 24.7 0 0 0 3.237-4.223c7.064-11.671 3.336-26.925-8.308-34.005-11.643-7.079-26.862-3.344-33.925 8.328s-3.336 26.925 8.307 34.004c7.443 4.524 16.337 4.613 23.638 1.053L81.994 95.4c.952 1.29 2.098 2.346 3.31 3.083.97.59 1.983.974 2.968 1.108 1.293.174 2.444-.103 3.332-.8.886-.699 1.426-1.753 1.562-3.054.232-2.228-.732-4.887-2.58-7.105m-53.68-26.138c-10.808-6.57-14.267-20.728-7.712-31.561 6.556-10.832 20.681-14.3 31.488-7.73s14.267 20.73 7.711 31.562-20.682 14.299-31.489 7.728zm54.495 33.058c-.06.565-.263 1.343-.894 1.841-.632.498-1.435.511-1.998.435-1.726-.233-3.675-1.568-5.089-3.486L61.218 64.238a24.5 24.5 0 0 0 4.183-3.081l23.824 28.612c1.524 1.83 2.36 4.047 2.177 5.782"
                />
            </g>
        </g>
        <defs>
            <clipPath id="clip0_9269_12549">
                <path fill="#fff" d="M0 0h116v116H0z" />
            </clipPath>
        </defs>
    </svg>
);

export default SearchWithStarts;
